<script setup>
import { reactive } from 'vue'
import MenuLayout from '../layout/MenuLayout.vue'
import { get, post } from '@/common/util'
import { useMetaStore } from '@/stores'
const meta=reactive({reqbtntk:'openapikeyrequest'}),metaStore=useMetaStore()
,reqApikey=async ()=>{
  metaStore.blockLoading()
  meta.apikeyreq=await post('rest/authed/member/reqapikey')
  meta.apikeyreq=meta.apikeyreq.data
  checkStat()
  metaStore.blockLoading(false)
},checkStat=()=>{
  if(meta.apikeyreq)meta.reqbtntk=meta.apikeyreq.apikey?'openapikeypublished':'applyforanopenapikeycomplete'
}
get('rest/authed/member/getapikeyreq',res=>{
  meta.apikeyreq=res.data
  checkStat()
})
</script>
<template>
  <MenuLayout>
    <v-card class="w-100 h-100 overflow-auto" flat>
      <v-card-title class="font-weight-black">
        <v-breadcrumbs :items="['applyforanopenapi']">
          <template #item="{item}">{{ $t(item.title) }}</template>
        </v-breadcrumbs>
      </v-card-title>
      <v-card-text>
        <v-card class="ma-3" flat>
          <v-card-title>Open API 소개</v-card-title>
          <v-card-text class="bg-amber-lighten-4 pa-4">
            Open API는 누구나 사용할 수 있도록 공개된 API를 말합니다.<br/>

            데이터를 표준화하고 프로그래밍해 외부 소프트웨어 개발자나 사용자가 바로 개발에 활용 할 수 있는 형태의 개방 형식입니다.<br/>

            개방된 Open API를 이용해 다양하고 재미있는 서비스나 애플리케이션, 다양한 형태의 플랫폼을 개발할 수 있습니다.
          </v-card-text>
        </v-card>
        <v-card class="ma-3" flat>
          <v-card-title>Open API 이용방법</v-card-title>
          <v-card-text>
            <v-stepper alt-labels>
              <v-stepper-header>
                <v-stepper-item value="1" title="1단계" subtitle="OPEN API 키 발급 신청"/>
                <v-divider/>
                <v-stepper-item value="2" title="2단계" subtitle="관리자 승인"/>
                <v-divider/>
                <v-stepper-item value="3" title="3단계" subtitle="OPEN API 데이터 활용"/>
              </v-stepper-header>
            </v-stepper>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col></v-col>
              <v-col><v-btn block size="x-large" color="primary" variant="elevated" :text="$t(meta.reqbtntk)" @click="reqApikey" :disabled="meta.reqbtntk!='openapikeyrequest'"/></v-col>
              <v-col></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-card flat class="ma-3 bg-grey-lighten-4">
          <v-card-text>
            확인하세요!<br/>
            (브랜드명)에서 제공하는 오픈 API는 자료는 수정 / 삭제될 수 있습니다.<br/>
            API 키는 마이페이지 > API 키 관리에서 확인하실 수 있습니다.
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </MenuLayout>
</template>
